import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Header from "../../layout/Header/Header";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
function BotonesRetiros() {
  const { user } = useContext(AuthContext);
  const [t, i18n] = useTranslation("global");
  return (
    <>
          <Header />
          {user.menuRetiros ?(
      <div className="container">
        <br />
        <br />
        <Row >

        <Col md={4} align="center">
          {user.menuSocios ?(
            <Button href="/Socios" className="botonesMenu" color="success">
              <i class="fas fa-users fa-7x"></i>
              <br />
              <br />
              {t("Socios")}
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-users fa-7x"></i>
          <br />
          <br />
          {t("Socios")}
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.retirosCreate ?(
            <Button href="/PorRetirar" className="botonesMenu" color="success">
              <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              {t("Por Retirar")}
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          {t("Por Retirar")}
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.retirosCreate ?(
            <Button href="/Retiros" className="botonesMenu" color="success">
              <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              {t("Retiros")}
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          {t("Retiros")}
        </Button> }
          </Col>

        </Row>
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesRetiros;
